export default function ShiftUtils(
  Authentication,
  PersonaCollection,
  EventProcessorService,
  EventCollection,
  Utils,
  ChooseService,
  ConfirmService,
  Restangular,
  AbsenceUtils,
  LeaveService,
  LaborUISchema,
  DayPartsService,
  AskSlotsService,
  ShiftAcceptanceUtils,
  sdk,
  extendCalendarModel,
  dateFilter,
  formatNumberFilter,
  uppercaseFirstFilter,
  toTimeFilter,
  toDateShortFilter,
  $q,
  $uibModal,
  $localStorage,
  $rootScope
) {
  'ngInject';

  const load = async () => {
    const ShiftUtilsAsync = (await import(/* webpackChunkName: "shifts" */ './ShiftUtilsAsync'))
      .default;
    Object.assign(
      this,
      new ShiftUtilsAsync(
        Authentication,
        PersonaCollection,
        EventProcessorService,
        EventCollection,
        Utils,
        ChooseService,
        ConfirmService,
        Restangular,
        AbsenceUtils,
        LeaveService,
        LaborUISchema,
        DayPartsService,
        AskSlotsService,
        ShiftAcceptanceUtils,
        sdk,
        extendCalendarModel,
        dateFilter,
        formatNumberFilter,
        uppercaseFirstFilter,
        toTimeFilter,
        toDateShortFilter,
        $q,
        $uibModal,
        $localStorage,
        $rootScope
      )
    );
  };

  this.asyncLoaded = false;
  this._asyncPromise = null;

  this.loadAsync = () => {
    if (!this._asyncPromise) {
      this._asyncPromise = load();
    }

    return this._asyncPromise;
  };

  if (__TEST__) {
    this.loadAsync();
    $rootScope.$digest();
  }
}
